import { Fragment, useRef, useState } from "react";
import PaystackPop from "@paystack/inline-js";
import { CartContext } from "../CartContext";
import { useContext } from "react";
import Header from "./Header&Footer/Header";
import { useNavigate } from "react-router-dom";
import Faq from "./Account/FAQ/FAQ";

const PaystackIntegration = () => {
  const navigate = useNavigate();
  const cart = useContext(CartContext);
  const emailRef = useRef();
  const amountRef = useRef();
  const lastNameRef = useRef();
  const firstNameRef = useRef();

  const [amount, setAmount] = useState("");

  const setAmountHandler = () => {
    setAmount(cart.getTotalCost().toFixed(2));
  };

  const paymentSubmitHandler = (e) => {
    e.preventDefault();
    const enteredEmail = emailRef.current.value;
    const enteredAmount = amountRef.current.value;
    const enteredFirstName = firstNameRef.current.value;
    const enteredLastName = lastNameRef.current.value;

    const paystack = new PaystackPop();
    paystack.newTransaction({
      key: "pk_live_542368d856f5d50ba7e31ef90363233c014e776c",
      amount: enteredAmount * 100,
      email: enteredEmail,
      firstName: enteredFirstName,
      lastName: enteredLastName,
      onSuccess(transaction) {
        let message = `Payment Complete! Reference ID: ${transaction.reference}`;
        alert(message);
      },
      onCancel() {
        alert("You Have Cancelled  a transaction");
      },
      callback: function (response) {
        navigate("/success", { replace: true });
      },
    });
  };

  return (
    <Fragment>
      <Header />
      <div className="container">
        <h1>Make Payment</h1>

        <form onSubmit={paymentSubmitHandler} id="paymentForm">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input ref={emailRef} type="email" id="email-address" />
          </div>
          <div className="form-group">
            <label htmlFor="amount">Amount</label>
            <input
              onChange={setAmountHandler}
              value={amount}
              ref={amountRef}
              type="tel"
              id="amount"
            />
          </div>
          <div className="form-group">
            <label htmlFor="first-name">First Name</label>
            <input ref={firstNameRef} type="text" id="first-name" />
          </div>
          <div className="form-group">
            <label htmlFor="last-name">Last Name</label>
            <input ref={lastNameRef} type="text" id="last-name" />
          </div>
          <div className="form-submit">
            <button type="submit">Pay</button>
          </div>
        </form>
      </div>
      <Faq />
    </Fragment>
  );
};

export default PaystackIntegration;
